import { BaseApi } from '@shared/config';
import type { GetSkillsRequest, GetSkillsResponse } from './types';

class SkillApi extends BaseApi {
  getSkills = (params: GetSkillsRequest): Promise<GetSkillsResponse> => {
    return this.instance.get('/skills', { params });
  };
}

export const skillApi = new SkillApi();
